export { SmartAppBanner } from './smart-app-banner';
